// extracted by mini-css-extract-plugin
export default {"container":"history_container__PUtUS","history":"history_history__--2L5"};